export default __webpack_public_path__ + "static/media/icon-casenotes.cb633cc3.svg";